import React from 'react';
import { FileText, Users, Image, Eye, Palette, Mail, BarChart3, User, GraduationCap, Globe, MessageCircle, Send, AtSign, UserCog } from 'lucide-react';

/**
 * Tab configuration for Admin Dashboard.
 * `roles` gates which logged-in role sees the tab — omit for admin-only.
 */
export const TAB_CONFIG = [
  { id: 'content', label: 'Content', icon: FileText, roles: ['admin'] },
  { id: 'students', label: 'Students', icon: GraduationCap, roles: ['admin'] },
  { id: 'team', label: 'Team', icon: Users, roles: ['admin'] },
  { id: 'languages', label: 'Languages', icon: Globe, roles: ['admin'] },
  { id: 'messagingApps', label: 'Messaging Apps', icon: MessageCircle, roles: ['admin'] },
  { id: 'images', label: 'Images', icon: Image, roles: ['admin'] },
  { id: 'visibility', label: 'Visibility', icon: Eye, roles: ['admin', 'manager'] },
  { id: 'design', label: 'Design', icon: Palette, roles: ['admin'] },
  { id: 'leads', label: 'Leads', icon: Mail, roles: ['admin', 'manager', 'agent'] },
  { id: 'autoReply', label: 'Auto-Reply', icon: Send, roles: ['admin'] },
  { id: 'emailSettings', label: 'Email Settings', icon: AtSign, roles: ['admin', 'manager'] },
  { id: 'teamAccounts', label: 'Team Accounts', icon: UserCog, roles: ['admin', 'manager'] },
  { id: 'analytics', label: 'Analytics', icon: BarChart3, roles: ['admin'] },
  { id: 'account', label: 'Account', icon: User, roles: ['admin', 'manager', 'agent'] }
];

/**
 * Admin Dashboard Tab Navigation
 */
const AdminTabs = ({ activeTab, setActiveTab, badges = {}, role = 'admin' }) => {
  const visibleTabs = TAB_CONFIG.filter((tab) => tab.roles.includes(role));
  return (
    <div className="flex gap-1 mb-6 border-b border-slate-200 overflow-x-auto">
      {visibleTabs.map(tab => {
        const Icon = tab.icon;
        const badgeCount = badges[tab.id];
        return (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            data-testid={`tab-${tab.id}`}
            className={`flex items-center gap-2 px-4 py-3 font-medium transition-colors border-b-2 -mb-px whitespace-nowrap relative ${
              activeTab === tab.id
                ? 'text-slate-900 border-slate-900'
                : 'text-slate-500 border-transparent hover:text-slate-700'
            }`}
          >
            <Icon className="w-4 h-4" /> {tab.label}
            {!!badgeCount && (
              <span
                data-testid={`tab-badge-${tab.id}`}
                className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-amber-500 text-white text-[11px] font-bold leading-none"
              >
                {badgeCount > 99 ? '99+' : badgeCount}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default AdminTabs;
